import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

export type WarehouseOption = {
  id: string;
  name: string;
};

type RequestParams = {
  subscriptionId: string;
};

export const getIntegrationWarehouses = async (
  scope: RequestScope,
  { subscriptionId }: RequestParams,
  options: ReadRequestOptions
): Promise<ChannelApiResponse<WarehouseOption[]>> => {
  try {
    const result = await scopedChannelApi(scope).get<WarehouseOption[]>('astur/integrations/channel/warehouses/list', {
      ...options,
      headers: buildAsturHeaders({ subscriptionId }),
    });

    return { data: result.data, status: result.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
